﻿import type { NuxtError } from '#app';

export default function getErrorMessage(error: NuxtError) {
    return getAllErrorMessages(error)[0] ?? 'Unknown error';
}
